import { useLang } from "../i18n";

const Row = ({ words }) => (
  <div className="flex shrink-0 items-center">
    {words.map((w) => (
      <span key={w} className="flex items-center font-display italic text-4xl md:text-7xl text-[#4A5D4E] px-6 md:px-10 whitespace-nowrap">
        {w}
        <svg viewBox="0 0 20 20" className="w-4 h-4 md:w-6 md:h-6 ml-12 md:ml-20 fill-[#B85D3B]"><path d="M10 0c1 6 4 9 10 10-6 1-9 4-10 10-1-6-4-9-10-10 6-1 9-4 10-10z" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const words = useLang().t.marquee;
  return (
  <section data-testid="marquee-section" className="bg-[#EFECE6] py-10 md:py-14 overflow-hidden border-y border-[#E2DDD5]">
    <div className="marquee-track flex w-max">
      <Row words={words} /><Row words={words} />
    </div>
  </section>
  );
};
